import Rebase from 're-base'
import firebase from 'firebase/app'
import 'firebase/database'

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyCuG06tuvkQbq7XfohdI1Dgud3ysLLWj0o",
    authDomain: "bonnevoie-61fd0.firebaseapp.com",
    databaseURL: "https://bonnevoie-61fd0.firebaseio.com",
})

const base = Rebase.createClass(firebase.database())

export { firebaseApp }

export default base